module.exports = __webpack_public_path__ + "img/waste-water.dfba7f9b.png";